import "regenerator-runtime/runtime";

let ATOMIC_CONFIG = {
  APIHost: window.atomic_config.APIHost, // https://documentation.atomic.io/guide/configuration/sdk-credentials
  APIKey: window.atomic_config.APIKey,
  environmentId: window.atomic_config.environmentId,
  targetUserId: checkAndStoreAtomicId(),
  JWT: "",
};

// Generates a random/anonymous id for use as the 'atomicId'
function generateAtomicId() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

// Function to attempt to get the client id from the GA cookie to pass to Atomic as a JWT claim to store against the user profile in Atomic
async function getClientIdFromGaCookie() {
  return new Promise((resolve) => {
    let attempt = 0;
    function parseId() {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; _ga=`);
      if (parts.length === 2) {
        const cid = parts.pop().split(";").shift();
        resolve(cid.split(".").slice(2).join("."));
      } else if (attempt < 4) {
        attempt++;
        setTimeout(() => {
          parseId();
        }, 200);
      } else {
        resolve(null)
      }
    }
    parseId();
  })
}

function checkAndStoreAtomicId() {
  let atomicId = localStorage.getItem("atomicId"); // Attempt to retrieve 'atomicId' from localStorage
  if (atomicId === null) {
    try {
      atomicId = generateAtomicId(); // Generate a new 'atomicId'
      localStorage.setItem("atomicId", atomicId); // Store the newly generated 'atomicId' in localStorage
    } catch (e) {
      // Log any errors, for example, if localStorage is not available
      console.error(
        "Error accessing localStorage or executing generateAtomicId:",
        e
      );
    }
  }
  return atomicId; // Return the 'atomicId', whether newly generated or retrieved from localStorage
}

function loadAtomic() {
  if (!ATOMIC_CONFIG.JWT) {
    console.error("loadAtomic called without a JWT, aborting");
    return;
  }
  AtomicSDK.initialise(
    ATOMIC_CONFIG.APIHost,
    ATOMIC_CONFIG.APIKey,
    ATOMIC_CONFIG.environmentId
  );

  AtomicSDK.enableDebugMode(3); // For testing

  AtomicSDK.onError = function (error) {
    // handle the reported error as required
    console.error("An error occured in the Atomic SDK: ", error);
  };

  AtomicSDK.setSessionDelegate(() => {
    return Promise.resolve(ATOMIC_CONFIG.JWT);
  });

  // Display a single card embedded in a content section
  // More options and config stuff here: https://documentation.atomic.io/sdks/web

  document.querySelectorAll(".atomicInline").forEach((element) => {
    const containerId = element.getAttribute("data-inline-container-id");

    //multi card WIP
    window.atomicInline = AtomicSDK.singleCard(element, {
      streamContainerId: containerId,
      onCardCountChanged: (count) => {
        if (count > 0) {
          let sibling = element.nextElementSibling;
          while (sibling) {
            if (sibling.classList.contains("e-atomic__spinner")) {
              sibling.style.display = "none";
              break;
            }
          }
        } else if (count === 0) {
          setTimeout(() => {
            let sibling = element.nextElementSibling;
            while (sibling) {
              if (sibling.classList.contains("e-atomic__spinner")) {
                sibling.style.display = "flex";
                break;
              }
            }
          }, 500);
        }
      },
    });

    // Check if the card is active every 20 seconds
    setTimeout(() => {
      AtomicSDK.requestUserMetrics()
        .then((metrics) => {
          console.log(
            `Cards active: ${metrics.metricsByContainer[containerId].active}`
          );
          if (metrics.metricsByContainer[containerId].active === 0) {
            console.log("Empty stream container logged");
            AtomicSDK.sendCustomEvent({
              eventName: `containerEmptyAfterWait-${containerId}`,
              properties: {
                containerId: containerId,
                actionFlowId: "wa7KYzqV",
              },
            }).catch((err) => {
              console.error(err);
            });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    }, 20000);
  });
}

async function getToken(userId) {
  const gaClientId = await getClientIdFromGaCookie() || "unknown";
  const fetchUrl = `${ATOMIC_CONFIG.APIHost}/${ATOMIC_CONFIG.environmentId}/unauthenticated-token/${userId}/${ATOMIC_CONFIG.APIKey}?claims=\{"gaClientId":"${gaClientId}"\}`;
  
  try {
    const res = await fetch(fetchUrl, {
      headers: {
        Origin: "*",
      },
    });
    const data = await res.json();
    if (!data.data.token) {
      console.error('No JWT available for authentication, retrying in 10s');
      return setTimeout(() => {
        getToken(userId);
      }, 10000);
    }

    ATOMIC_CONFIG.JWT = data.data.token;
    loadAtomic();
    setupInlineCardObserver();
    setupContainerResizeObservers();

  } catch (error) {
    console.error('No JWT available for authentication, retrying in 10s');
    return setTimeout(() => {
      getToken(userId);
    }, 10000);
  }
}

// The following is unique to the SBS website concept where we're wanting to show the second iFrame/subview in the same spot as the main/first card
// but we don't want to show both at once. So this hides the top level card container when a secondary view is visible, and shows it aqain as needed.

function toggleVisiblityOfInlineCard(added) {
  const element = document.querySelector(
    ".atomic-sdk-frame.single-card.has-card"
  );
  if (!element) {
    return;
  }
  if (added) {
    document.querySelector(
      ".atomic-sdk-frame.single-card.has-card"
    ).style.display = "none";
  } else {
    document.querySelector(
      ".atomic-sdk-frame.single-card.has-card"
    ).style.display = "inline";
  }
}

function setupInlineCardObserver() {
  //todo update to work with multi card
  const inlineCardObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (
        mutation.type === "attributes" &&
        mutation.attributeName === "class"
      ) {
        const target = mutation.target;
        if (
          target.tagName === "IFRAME" &&
          target.classList.contains("atomic-sdk-frame") &&
          target.classList.contains("modal-subview")
        ) {
          const currentHasCard = target.classList.contains("has-subview");
          const previousHasCard = mutation.oldValue.includes("has-subview");
          if (currentHasCard !== previousHasCard) {
            // Check if there's a change in the 'has-card' status
            toggleVisiblityOfInlineCard(currentHasCard); // True if added, false if removed
          }
        }
      }
    });
  });

  inlineCardObserver.observe(document.body, {
    subtree: true,
    attributes: true,
    attributeOldValue: true, // Necessary to access the previous value of the class attribute
    attributeFilter: ["class"],
  });
}

function setupContainerResizeObservers() {
  //todo update to work with multi card
  const embedContainer = document.querySelectorAll(".atomicInline")[0];
  const streamContainer = document.querySelector(
    ".atomic-sdk-frame.single-card"
  );
  const modalSubviewContainer = document.querySelector(
    ".atomic-sdk-frame.modal-subview"
  );

  const containerResizeObserver = new ResizeObserver((entries) => {
    entries.forEach((entry) => {
      if (
        entry.target.tagName === "IFRAME" &&
        entry.target.classList.contains("atomic-sdk-frame")
      ) {
        const height = entry.borderBoxSize[0].blockSize;
        if(height != 0){
          // console.log('streamContainer height: ', height);
          embedContainer.style.height = `${height}px`;
        }
      }
    });
  });

  const modalSubviewResizeObserver = new ResizeObserver((entries) => {
    entries.forEach((entry) => {
      if (
        entry.target.tagName === "IFRAME" &&
        entry.target.classList.contains("has-subview") &&
        entry.target.classList.contains("modal-subview")
      ) {
        const height = entry.borderBoxSize[0].blockSize;
        if(height != 0){
          // console.log('modalSubviewContainer height: ', height);
          embedContainer.style.height = `${height}px`;
        }
      }
    });
  });

  containerResizeObserver.observe(streamContainer, {
    box: "border-box",
  });
  modalSubviewResizeObserver.observe(modalSubviewContainer, {
    box: "border-box",
  });
}

// The following is an example of how the client side can listen to the Atomic's SDK events
// This is how we can respond to SDK events and call methods on the GA SDK for instance, to log events with GA
// which occurred in Atomic. PS or Atomic can flesh this out as we get close to launch and have the code running alongside the real GA snippets.
// For now it is just an example
async function init() {
  if (!window.AtomicSDK) {
    console.log("Atomic SDK not loaded yet, retrying...");
    // Atomic SDK not loaded yet, retry. Could extend this to remove the loader from the page if the SDK fails to load for some reason?
    return setTimeout(init, 100);
  }
  console.log("Atomic SDK available");
  await AtomicSDK.logout();

  getToken(ATOMIC_CONFIG.targetUserId);
}

async function waitForCookie(maxAttempts = 50, interval = 100) {
  let attempts = 0;

  async function checkCookie() {
    attempts++;
    const cookieValue = await getClientIdFromGaCookie();
    if (cookieValue) {
      init();
    } else if (attempts < maxAttempts) {
      // console.log(`Attempt ${attempts}.`);
      setTimeout(checkCookie, interval);
    } else {
      // console.log(`Not set after ${maxAttempts} attempts.`);
      init();
    }
  }

  checkCookie();
}

waitForCookie(15);